export interface SceneParams {
  // Model
  modelScale: number
  modelPosX: number
  modelPosY: number
  modelPosZ: number

  // Camera
  camX: number
  camY: number
  camZ: number
  camFov: number
  camTargetX: number
  camTargetY: number
  camTargetZ: number

  // Fog
  fogColor: string
  fogNear: number
  fogFar: number

  // Hemisphere light
  hemSkyColor: string
  hemGroundColor: string
  hemIntensity: number

  // Directional light 1 (sun)
  dir1Color: string
  dir1Intensity: number
  dir1X: number
  dir1Y: number
  dir1Z: number

  // Directional light 2 (fill)
  dir2Color: string
  dir2Intensity: number
  dir2X: number
  dir2Y: number
  dir2Z: number

  // Snow particles
  snowCount: number
  snowSpeed: number
  snowSize: number
  snowOpacity: number

  // Mist particles
  mistOpacity: number
  mistSpeed: number
  mistSize: number

  // Post-processing
  bloomIntensity: number
  bloomThreshold: number
  dofFocusDistance: number
  dofFocusRange: number
  dofBokeh: number
  vignetteDarkness: number

  // Skybox
  skyboxRotation: number
  skyboxBlur: number
}

export const defaultParams: SceneParams = {
  modelScale: 50,
  modelPosX: -19.75,
  modelPosY: 2.45,
  modelPosZ: -7.4,

  camX: -8.7,
  camY: 2.65,
  camZ: 0.1,
  camFov: 47,
  camTargetX: -4.85,
  camTargetY: 3.65,
  camTargetZ: -2.25,

  fogColor: '#F0EEE4',
  fogNear: 5,
  fogFar: 20,

  hemSkyColor: '#EDE8DC',
  hemGroundColor: '#E5E0D5',
  hemIntensity: 0.55,

  dir1Color: '#FFF8F0',
  dir1Intensity: 1.8,
  dir1X: -6,
  dir1Y: 10.2,
  dir1Z: 0.6,

  dir2Color: '#F0EBE0',
  dir2Intensity: 1.5,
  dir2X: 4,
  dir2Y: 6,
  dir2Z: 2,

  snowCount: 12000,
  snowSpeed: 0.14,
  snowSize: 0.03,
  snowOpacity: 1,

  mistOpacity: 0.3,
  mistSpeed: 1.75,
  mistSize: 30,

  bloomIntensity: 0.53,
  bloomThreshold: 0.82,
  dofFocusDistance: 7.5,
  dofFocusRange: 5.3,
  dofBokeh: 2.35,
  vignetteDarkness: 0,

  skyboxRotation: -0.63,
  skyboxBlur: 0.05,
}
